import {css} from '@sail/engine/deprecated';
import {LinkTheme, linkColors} from './link';
import {Theme} from './theme';

export const linkAssistantColors = {
  ...linkColors,
};

export const LinkAssistantTheme: Theme = {
  ...LinkTheme,
  buttonBackgroundImage: `linear-gradient(white, white), linear-gradient(${linkAssistantColors.neutralBorder}, ${linkAssistantColors.neutralBorder})`,
  buttonBorderWidth: '1px',
  buttonHoverColor: linkAssistantColors.brand600,
  messageBubbleBackground: linkAssistantColors.brand600,
  primaryActionColor: linkColors.neutral900,
  pressedShadow: linkColors.brand1000,
  onCtaTextColor: linkColors.neutral,
  ctaColor: linkColors.neutral900,
  ctaHoverColor: linkColors.neutral900,
  focusVisibleOutline: css.value(`2px solid ${linkColors.neutral900}`),
  formBorderColor: linkColors.neutralBorder,
};
